import { render } from "./TableHeader.vue?vue&type=template&id=24a73494"
import script from "./TableHeader.vue?vue&type=script&lang=ts"
export * from "./TableHeader.vue?vue&type=script&lang=ts"
script.render = render

export default script